/**
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/head/namespaces";
import { asExport } from "@gr-exports/head/core";
import { noop } from "@gr-common/head/function";
/**
 *
 */
export const cookie = /*           */ asExport(o_util, "cookie", {});
/**
 *
 *
 *
 */
export const exists = /*           */ asExport(cookie, "exists", noop);
/**
 *
 *
 *
 */
export const get = /*           */ asExport(cookie, "get", noop);
/**
 *
 *
 *
 */
export const remove = /*           */ asExport(cookie, "remove", noop);
/**
 *
 *
 *
 */
export const set = /*           */ asExport(cookie, "set", noop);
